<div class="contact-card-container pointer" [class.is-read]="contact.isRead" (click)="toggleMenu($event)" [title]="'Détails ' + contact.fullName">
    <div class="contact-card">
        <div class="contact-image-col">
            <img [src]="contact.isRead ? './assets/images/icons/mail-read.png' : './assets/images/icons/mail-default.png'" [alt]="contact.fullName" class="contact-image">
        </div>

        <div class="contact-content-col">
            <div class="col-header">
                <h3 class="contact-title"><strong>{{ contact.fullName }} </strong>/ {{contact.email}}</h3>
                <div class="right-side">
                    <div class="status-badge">
                        <span class="status-dot" [class.public]="contact.isRead" [class.private]="!contact.isRead"></span>
                        <span class="status-text">{{ contact.isRead ? 'Lu' : 'Non lu' }}</span>
                    </div>
                    <div *ngIf="contact.isArchived" class="status-badge">
                        <span class="status-dot private"></span>
                        <span class="status-text">Archivé</span>
                    </div>
                    <button class="card-menu-btn" type="button" (click)="toggleMenu($event)">
                        <img src="./assets/images/icons/menu-drop.png" alt="menu" class="menu-icon">
                    </button>
                </div>
            </div>

            <div class="contact-footer">
                <p class="contact-description">
                    {{ truncateSubject() }}
                </p>
                <div class="creation-date">
                    {{ contact.createdAt }}
                </div>
            </div>
        </div>
    </div>

    <div class="popup-menu" *ngIf="menuOpen">
        <div class="arrow"></div>
        <ul>
            <li (click)="details()">
                <img src="./assets/images/icons/details.png" alt="View"> Details
            </li>
            <li *ngIf="!contact.isArchived" (click)="toggleVisibility()">
                <img class="lock" src="./assets/images/icons/eye.png" alt="Visibility"> {{ contact.isRead ? 'Marquer comme non lu' : 'Marquer comme lu' }}
            </li>
            <li (click)="toggleArchive()">
                <img class="lock" src="./assets/images/icons/archive.png" alt="Archiver"> {{ contact.isArchived ? 'Désarchiver' : 'Archiver' }}
            </li>
            <li *ngIf="!contact.isArchived" (click)="confirmDelete()" class="delete-item">
                <img src="./assets/images/icons/trash.png" alt="Delete"> Supprimer
            </li>
        </ul>
    </div>
</div>

<div class="confirmation-modal-overlay" *ngIf="showDeleteModal">
    <div class="confirmation-modal">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p>Êtes-vous sûr de vouloir supprimer cette demande <br><strong>"{{ contact.fullName  }}"</strong> (<small>{{contact.email}}</small>) </p>
            <p>"{{contact.subject}}"?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="deleteContact()">Supprimer</button>
        </div>
    </div>
</div>